import RSVP from 'rsvp';
import $ from 'jquery';

const IntegrationService = {
  promises: {},

  attachListener() {
    $.receiveMessage((evt) => {
      let data;
      let key;

      // Respond only to messages that you are interested in. Event data will be in the form
      // "_action=viewport%23queryPosition&isConsistent=1&centersDelta=-1394&height=962"
      if (
        !evt.data ||
        !(typeof evt.data === 'string') ||
        evt.data.indexOf('_action') < 0
      ) {
        return;
      }
      data = $.deparam(evt.data || '');
      key = data._action;

      if (this.promises[key]) {
        this.resolveQueuedPromise(key, data);
      }
    });
  },

  queuePromise(key, promiseBody) {
    let promise;

    promise = new RSVP.Promise((resolve, reject) => {
      this.promises[key] = {
        promise,
        resolve,
        reject,
      };

      promiseBody.call(this, resolve, reject);
    });

    return promise;
  },

  resolveQueuedPromise(key, data) {
    if (this.promises[key]) {
      delete data._action;
      this.promises[key].resolve(data);
      delete this.promises[key];
    }
  },

  queryParentViewport() {
    const key = 'viewport#queryPosition';

    return this.queuePromise(key, (resolve, reject) => {
      $.postMessage({ _action: key }, '*');
    });
  },

  queryOriginUrl() {
    const key = 'viewport#queryURL';

    return this.queuePromise(key, () => {
      $.postMessage({ _action: key }, '*');
    });
  },

  scrollInView(offset) {
    const key = 'viewport#scrollInView';

    return this.queuePromise(key, (resolve, reject) => {
      $.postMessage({ _action: key, offset }, '*');
    });
  },

  scrollRelative(scroll) {
    $.postMessage(
      {
        _action: 'viewport#scrollRelative',
        scroll,
      },
      '*'
    );
  },
};

export default IntegrationService;
